<!-- 消息明細：/news_detail -->
<template>
  <div class="layout_wrapper">
    <div class="container_wrapper">
      <h3 class="page_main_title">
        {{ currentDetail.data.title }}
      </h3>

      <span class="tag_text">
        {{ currentDetail.data.category }}
      </span>

      <span class="date_time">
        {{ currentDetail.data.date }}
      </span>

      <div class="content">
        <template
          v-for="(item, idx) in paragraphData"
          :key="idx"
        >
          <div v-if="isUrl(item)">
            <div
              v-if="imageTypeList.indexOf(getImgType(item)) !== -1"
              class="img_block"
            >
              <picture>
                <source
                  media="(min-width: 768px) and (max-width: 1024px)"
                  :srcset="String(item.replace(/^(.*).(png|jpg|jpeg|svg|gif)$/gm, '$1@2x.$2'))"
                >
                <source
                  media="(max-width: 414px)"
                  :srcset="item"
                >

                <img
                  :srcset="String(item.replace(/^(.*).(png|jpg|jpeg|svg|gif)$/gm, '$1@3x.$2'))"
                  alt=""
                >
              </picture>
            </div>

            <a
              v-else
              :href="item"
              target="_blank"
              class="external_link"
            >
              {{ item }}
            </a>
          </div>

          <div
            v-else
            class="detail_content"
            v-html="item"
          />
        </template>
      </div>
    </div>

    <component :is="dialogName" />
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { AppDialog } from '@/components/Modal/';
import { getNewsList } from '@/libs/API/apis';
import useCommon from '@/libs/globalComposition';

export default {
  name: 'NewsDetail',
  components: {
    AppDialog
  },
  setup () {
    const { currentRoute, dialogName } = useCommon();
    let newsContent = {};

    const paragraphData = ref([]);
    const imageTypeList = ref(['png', 'jpg', 'jpeg', 'svg', 'gif']);

    const currentDetail = reactive({ data: {} });

    const isUrl = (url) => {
      const replaceUrlNewline = url.trim().replace(/[\r\n]/g, '');

      return /^(https?:\/\/.)(www\.)?[-a-zA-Z\d@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z\d@:%_+.~#?&/=]*)$/g
        .test(replaceUrlNewline);
    };

    const getImgType = (url) => {
      return url.replace(/^(.*)\.([a-zA-Z]+)[\r\n]?$/gm, '$2');
    };

    onMounted(() => {
      getNewsList().then((res) => {
        newsContent = res;

        let arrangeNewsData = {};

        Object.keys(newsContent).forEach((item, idx) => {
          arrangeNewsData = { ...arrangeNewsData, ...newsContent[item] };
        });

        currentDetail.data = arrangeNewsData[currentRoute.params.id];
        paragraphData.value = currentDetail.data.content.split('\n');
      });
    });

    return {
      dialogName,
      paragraphData,
      imageTypeList,
      currentDetail,
      isUrl,
      getImgType
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';
@import '@/scss/common/layout.scss';

.layout_wrapper {
  .page_main_title {
    margin: 0px 0px 20px;
  }

  .tag_text {
    @include font-size-bold-18;

    background: $news_color;
    margin: 0px 10px 0px 0px;
    padding: 4px 8px;
  }

  .date_time {
    @include font-size-bold-18;

    color: $mono_80;
    margin: 20px 0px 0px 0px;
  }

  .content {
    .img_block {
      margin: 50px 0px 50px 0px;
      width: 100%;

      img {
        display: block;
        margin: auto;
        max-height: 568px;
        width: auto;
      }
    }

    .external_link {
      font-size: 18px;
    }

    .detail_content {
      @include font-size-18;

      color: $mono_80;
      letter-spacing: 0.2px;
      margin: 20px 0px;
      min-height: 16px;

      ::v-deep(a) {
        color: $green;
        cursor: pointer;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      ::v-deep(h1) {
        @include font-size-bold-30;

        margin: 0px;
      }

      ::v-deep(h2) {
        font-size: 22px;
        font-weight: 700;
        line-height: 32px;
        margin: 0px;
      }

      &:last-child {
        padding-bottom: 100px;
      }
    }
  }
}

@include RWD_1024 {
  .layout_wrapper {
    .content {
      .img_block {
        img {
          max-height: 450px;
        }
      }
    }
  }
}

@include RWD_768 {
  .layout_wrapper {
    .content {
      .img_block {
        img {
          max-height: 364px;
        }
      }
    }
  }
}

@include RWD_414 {
  .layout_wrapper {
    .page_main_title {
      margin: 0px 0px 10px;
    }

    .date_time {
      margin: 10px 0px 0px 0px;
    }

    .content {
      @include font-size-16;

      .img_block {
        margin: 20px 0px;

        img {
          max-height: (192 / 414) * 100vw;
        }
      }

      &:last-child {
        margin-bottom: 50px;
      }
    }
  }
}
</style>
